import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmuctuyenxedien from "components/Danhmuc/Tuyenxedien/Danhmuctuyenxedien.js";
export default function Dmtuyenxedien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Danh mục tuyến xe điện",
            tabContent: <Danhmuctuyenxedien />,
          },
        ]}
      />
    </div>
  );
}
